import moment from 'moment';
export default class FTPFileModel {
  id: string;
  description: string;
  additionalStaffNotes: string;
  fileNumber: string;
  board: string;
  staff: string[];
  email: string;
  fileId: string;
  projectName: string;
  createdAt?: string;
  loading: boolean;

  constructor(data?: any) {
    this.id = data?.id || undefined;
    this.description = data?.description || undefined;
    this.additionalStaffNotes = data?.additionalStaffNotes || undefined;
    this.fileNumber = data?.fileNumber || undefined;
    this.board = data?.board.abbreviation || undefined;
    this.staff = data?.staff.map(s => s.displayName) || undefined;
    this.email = data?.email || undefined;
    this.fileId = data?.fileId || undefined;
    this.projectName = data?.projectName || undefined;
    this.createdAt = data?.createdAt ? moment.unix(data.createdAt).format('DD MMM YYYY') : undefined;
    this.loading = false;
  }
}
